import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const CroppedEllipse: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <ellipse
        rx="53.62"
        ry="53.849"
        transform="matrix(-1 0 0 1 -50.038 130.752)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="65.225"
        ry="65.505"
        transform="matrix(-1 0 0 1 -50.037 130.752)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="75.903"
        ry="76.228"
        transform="matrix(-1 0 0 1 -50.038 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="86.581"
        ry="86.951"
        transform="matrix(-1 0 0 1 -50.037 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="98.186"
        ry="98.607"
        transform="matrix(-1 0 0 1 -50.038 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="108.864"
        ry="109.33"
        transform="matrix(-1 0 0 1 -50.036 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="120.47"
        ry="120.985"
        transform="matrix(-1 0 0 1 -50.037 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="131.612"
        ry="132.175"
        transform="matrix(-1 0 0 1 -50.037 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="142.753"
        ry="143.364"
        transform="matrix(-1 0 0 1 -50.036 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="153.895"
        ry="154.554"
        transform="matrix(-1 0 0 1 -50.036 130.752)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="164.573"
        ry="165.277"
        transform="matrix(-1 0 0 1 -49.573 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="175.714"
        ry="176.466"
        transform="matrix(-1 0 0 1 -49.572 130.752)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="186.856"
        ry="187.656"
        transform="matrix(-1 0 0 1 -49.572 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
      <ellipse
        rx="197.534"
        ry="198.379"
        transform="matrix(-1 0 0 1 -49.572 130.753)"
        stroke={props.stroke}
        strokeWidth="2"
      />
    </svg>
  );
};

export { CroppedEllipse };
